import React from 'react';
import { useAppSelector } from 'hooks/redux';
import {
  AuthSearchBlock,
  NoAuthSearchBlock,
} from 'components/SearchTab/SearchInput/Search';

export const SearchInput: React.FC<{
  search: () => void;
}> = ({ search }) => {
  const { isLogged } = useAppSelector((state) => state.mainPage);
  return isLogged ? (
    <AuthSearchBlock search={search} />
  ) : (
    <NoAuthSearchBlock search={search} />
  );
};
